<template>
  <div>
    <v-modal 
    class="grapesjs-modal"
    v-model="modal_edit_open">
      
      <vue-grapesjs v-if="modal_edit_open"
      :id.sync="edit_item.id"
      :subject="edit_item.subject"
      :content="edit_item.content"
      :is_template="is_template"
      @close="modal_edit_open = false"
      @msg_update="get_messages"/>
    </v-modal>

    <v-modal
    class="message-modal"
    v-model="modal_del_confirm">
      <div class="rows is-full-height is-gapless"
      style="width: 900px; max-width: 100%;">
        <div class="row is-narrow">
          <nav class="navbar primary"
          style="padding: 10px;">
            <span>Suppression</span>
          </nav>
        </div>
        <div class="row"
        style="padding: 10px;">
          <span v-if="is_template == 0">Supprimer le message?</span>
          <span v-else>Supprimer le template?</span>
        </div>

        <div class="row is-narrow">
          <nav class="navbar primary">
            <div
            class="button primary full-width"
            style="border: 0;"
            @click="item_del">Confirmer</div>
            </nav>
          </nav>
        </div>

      </div>
    </v-modal>

    <v-modal
    class="message-modal"
    v-model="modal_template_choose_open">
      <div class="rows is-full-height is-gapless"
      style="width: 900px; max-width: 100%;">
        <div class="row is-narrow">
          <nav class="navbar primary"
          style="padding: 10px;">
            <span>Choix template</span>
          </nav>
        </div>
        <div class="row"
        style="padding: 10px;">
          <div class="button"
          @click.prevent="on_start_from_template(null)">Démarrer un message vide</div>
        </div>
        <div class="row"
        style="padding: 10px;">
          <div>Ou sélectionner un template:</div>
        </div>

        <div class="row border-row"
        v-for="template in templates">
          <div class="list form column is-24"
          style="position: relative; ">
            <div class="item">
              <div class="columns is-mobile"
              style="padding: 0 1rem;">
                <div class="column is-12 button"
                  @click.prevent="on_start_from_template(template)">
                  <span
                  v-html="template.subject"></span>
                </div>

              </div>
            </div>
          </div>
        </div>

      </div>
    </v-modal>

    <div class="rows is-full-height is-gapless">
      <div class="row is-narrow"
      style="margin-bottom: 20px;">
        <nav class="navbar primary">
          <div class="navbar-nav search-nav">
            <div class="columns is-gapless">
              <div class="column is-5">
                <div class="button"
                @click="on_add_item">
                  <span v-if="is_template == 0">Nouveau message</span>
                  <span v-else>Nouveau template</span>
                </div>
              </div>
              <div class="column is-5">
              </div>
            </div>
          </div>
        </nav>
      </div>

      <div class="row border-row"
      v-for="item in items">
        <div class="msg-list list form column is-24"
        style="position: relative; ">
          <div class="item">
            <div class="columns is-mobile">
              <div class="column is-10">
                <v-input class="floating-label full-width"
                :isDisabled="true"
                v-model="item.subject"
                placeholder="Nom">
                </v-input>
              </div>
              <!-- <div class="column is-5">
                <v-input class="floating-label full-width"
                :isDisabled="true"
                v-model="item.group_name"
                placeholder="Groupe">
                </v-input>
              </div> -->
              <div class="column is-2"
              style="padding-top: 14px;">
                <div 
                class="button"
                style="float: right; margin-left: 10px;"
                v-no-select
                @click.prevent="on_del_item(item)">
                  <i class="remove"></i>
                </div>
                <div 
                class="button"
                style="float: right;"
                v-no-select
                @click.prevent="on_edit_item(item)">
                  <i class="pencil"></i>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import Vuex from 'vuex'
import typeahead from '../components/utils/typeahead.js'

import VueGrapesjs from '../components/grapesjs'
Vue.component('vue-grapesjs', VueGrapesjs)

export default {
  data: function () {
    return {
      edit_item: {
        id: 0,
        title: '',
        content: ''
      },
      items: [],
      templates: [],
      modal_edit_open: false,
      modal_del_confirm: false,
      modal_template_choose_open: false,
      is_template: 0,
    }
  },
  computed: {
    ...Vuex.mapGetters({

    })
  },
  mounted: function () {

    // console.log('route', this.$route)

    if(this.$route.name === 'mailing_templates'){
      this.is_template = 1
    }

    this.get_messages()
  },
  methods: {
    get_blank_messsage: function () {
      return {
        id: -Math.floor(Math.random() * Math.floor(1000000)),
        subject: '',
        content: ''
      }
    },
    on_add_item: function () {
      let vm = this
      if(this.is_template === 0) {
        this.get_templates()
        .then(function(){
          vm.modal_template_choose_open = true
        })
      }
      else {
        this.edit_item = this.get_blank_messsage()

        this.modal_edit_open = true
      }
    },
    on_edit_item: function (item) {
      // this.edit_item = item
      // this.modal_edit_open = true
      this.$http.post(
        global.app_path + 'main.php?action=get_message',
        {
          id: item.id,
          token: global.token
        })
      .then(function (response) {

        var body = response.body

        if(body.ok){
          this.edit_item = body.item
          this.modal_edit_open = true
        }
      },
      function (response) {

      })
    },
    on_del_item: function (item) {
      this.edit_item = item

      this.modal_del_confirm = true
    },
    item_del: function () {
      var vm = this
      var item = this.edit_item
      var index = vm.items.indexOf(item)
      // console.log('index', index)

      this.$http.post(
        global.app_path + 'main.php?action=del_message',
        {
          id: item.id,
          token: global.token
        })
      .then(function (response) {
        vm.items.splice(index, 1)

        vm.modal_del_confirm = false
      },
      function (response) {

      })
    },
    // item_submit: function () {
    //   var vm = this
    //   this.$http.post(
    //     global.app_path + 'main.php?action=set_message',
    //     {
    //       id: this.edit_item.id,
    //       title: this.edit_item.title,
    //       group_id: this.edit_item.group_id,
    //       is_template: vm.is_template,
    //       token: global.token
    //     })
    //   .then(function (response) {
    //     if(Number(vm.edit_item.id) === 0) {
    //       var body = response.body
    //       vm.edit_item.id = Number(body.id)
    //       vm.items.push(vm.edit_item)
    //     }
    //     vm.modal_edit_open = false
    //   },
    //   function (response) {

    //   })
    // },
    get_messages: function () {
      var vm = this
      this.$http.post(
        global.app_path + 'main.php?action=get_messages', {
          is_template: vm.is_template,
          token: global.token
        }
      )
      .then((response) => {
        if(response &&
        response.body &&
        response.body.messages) {
          vm.items = response.body.messages
        }
      }, (response) => {

      })
    },
    get_templates: function () {
      var vm = this
      return this.$http.post(
        global.app_path + 'main.php?action=get_messages', {
          is_template: 1,
          token: global.token
        }
      )
      .then((response) => {
        if(response &&
        response.body &&
        response.body.messages) {
          vm.templates = response.body.messages
        }
      }, (response) => {

      })
    },
    on_start_from_template: function (item) {
      var vm = this

      vm.modal_template_choose_open = false

      if(item){
        this.$http.post(
          global.app_path + 'main.php?action=get_message',
          {
            id: item.id,
            token: global.token
          })
        .then(function (response) {

          var body = response.body

          if(body.ok){
            this.edit_item.id = 0
            this.edit_item.subject = ''
            this.edit_item.content = body.item.content
            this.modal_edit_open = true
          }
        },
        function (response) {

        })
      }
      else {
        this.edit_item.id = 0
        this.edit_item.subject = ''
        this.edit_item.content = ''
        this.modal_edit_open = true
      }
    },

  }
}
</script>
<style>
h2 {
  margin: 0.5em 0 .5em;
  padding-bottom: .4em;
  border-bottom: 1px solid #ddd;
  font-weight: 600;
  color: #286fa3;
  display: block;
  font-size: 1.2rem;
}

i.plus {
  font-size: 1rem;
  line-height: 2rem;
  position: relative;
}

.add-btn .button{
  margin: 0px;
  padding: 0px 10px;
  display: inline-block;
  line-height: 2rem;
}

.add-btn {
  padding: 0 0.5rem !important;
  margin-top: 0.5rem !important;
}

.msg-list.form .column {
  padding-right: 1.25rem !important;
  padding-top: 0.25rem;
}

.border-row > .list {

}

.border-row + .border-row > .list {
  border-top-width: 0;
}

.message-modal .modal-content {
  overflow: visible;
}

.grapesjs-modal.modal {
  transition: none;
  display: block;
  pointer-events: none;
}

.grapesjs-modal .modal-content {
  transition: none;
  width: 100vw;
  height: 100vh;
  max-height: 100vh;
  pointer-events: all;
}
</style>
